import {date} from "uloc-vue"
import {mockEndereco} from "@/components/pessoa/mock/endereco"
import {mockTelefone} from "@/components/pessoa/mock/telefone"
import {mockEmail} from "@/components/pessoa/mock/email"
import {mockDocument} from "@/components/pessoa/mock/document"

export const adjustPurposes = function (objs) {
  objs.map(obj => {
    obj && obj.map(item => {
      if (item.purpose && item.purpose.id) {
        item.purpose = item.purpose.id
      }
    })
  })
}

export const adjustPersonData = function (data, minPhones = 3, minDocs = 1) {
  let p = data
  if (data.pessoa) {
    p = data.pessoa
  }
  if (p && p.birthDate && typeof p.birthDate.date !== "undefined") {
    p.birthDate = date.formatDate(p.birthDate.date, 'DD/MM/YYYY')
  }
  // let mock = JSON.parse(JSON.stringify(mockArrematante))
  // console.log(mock)
  // this.arrematante = Object.assign(mock, data)
  // console.log(this.arrematante)
  if (!p.addresses || p.addresses.length === 0) {
    p.addresses = [JSON.parse(JSON.stringify(mockEndereco))]
  }

  if (!p.phoneNumbers || p.phoneNumbers.length < minPhones) {
    if (!Array.isArray(p.phoneNumbers)) {
      p.phoneNumbers = []
    }
    const len = minPhones - Number(p.phoneNumbers.length)
    for (let i = 0; i < len; i++) {
      p.phoneNumbers.push(JSON.parse(JSON.stringify(mockTelefone)))
    }
  }

  if (!p.emails || p.emails.length === 0) {
    p.emails = [JSON.parse(JSON.stringify(mockEmail))]
  }

  if (!p.documents || p.documents.length === 0) {
    if (minDocs > 0) {
      p.documents = [JSON.parse(JSON.stringify(mockDocument))]
    }
  }

  adjustPurposes([
    p.addresses,
    p.phoneNumbers,
    p.contacts,
    p.emails
  ])

  return p
}
